export default __webpack_public_path__ + "comment-white-oval-bubble.png";